import { createAction } from 'redux-actions';
import {
  PapiDaUserProfileInitStats,
  PapiDaUserProfileStatsMyContent,
  PapiUser,
  PapiDataPackageCompareYourself,
} from '@wix/da-types-papi';
import {
  StatsTimePeriod,
  MySubmissionsSortBy,
  BenchmarkSortBy,
} from '../../types/statsSection';

export const setStats = createAction<PapiDaUserProfileInitStats['sectionData']>(
  'STATS_SECTION/SET_STATS'
);

export const setMySubmissionsStats = createAction<
  PapiDaUserProfileStatsMyContent['myContent']
>('STATS_SECTION/SET_MY_SUBMISSIONS_STATS');

export const setTimePeriod = createAction<StatsTimePeriod>(
  'STATS_SECTION/SET_TIME_PERIOD'
);

export const setMySubmissionsSortBy = createAction<MySubmissionsSortBy>(
  'STATS_SECTION/SET_MY_SUBMISSIONS_SORT_BY'
);

export const setMySubmissionsIsLoading = createAction<boolean>(
  'STATS_SECTION/SET_MY_SUBMISSIONS_IS_LOADING'
);

export const setBenchmarkSortBy = createAction<BenchmarkSortBy>(
  'STATS_SECTION/SET_BENCHMARK_SORT_BY'
);

export const removeBenchmarkUser = createAction<number>(
  'STATS_SECTION/DELETE_BENCHMARK_USER'
);

export const addBenchmarkUser = createAction<number>(
  'STATS_SECTION/ADD_BENCHMARK_USER'
);

export const addBenchmarkUserSuccess = createAction<{
  timePeriods: PapiDataPackageCompareYourself['timePeriods'];
}>('STATS_SECTION/ADD_BENCHMARK_USER_SUCCESS');

export const sendQuery = createAction<string>('STATS_SECTION/SEND_QUERY');

export const resultUserQuery = createAction<PapiUser[]>(
  'STATS_SECTION/SEND_USER_QUERY_SUCCESSFUL'
);
